import React, { useEffect, useState } from 'react';
import BucketCartItems from './BucketCartItems';
import BucketCart from './BucketCart';
import GoogleIcon from '../../Assetes/Images/google-icon.svg'
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Link } from 'react-router-dom';
import OtpModal from './OtpModal';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import LoginDetail from './GuestLoginDetail';
import { toast } from 'react-toastify';
import { connect, useSelector } from 'react-redux';
import { addGuest, sendOtp, guestVerifyOtp, changePasswordOtp, customerSignIn, loginCustomerWithSocial, signupNew, getConsentConfig } from '../../Redux/actions/customer';
import Header from '../../Components/Header';
import useTrackEvent from '../../hooks/useTrackHook';
import FacebookLogin from 'react-facebook-login';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
// import { FACEBOOK_APP_ID } from '../../Components/client-config';
import GoBack from '../BackButton/GoBack';
import { v4 as uuid } from 'uuid';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { checkPhone, MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';
import type { ConsentConfig } from '../../Components/ConsentCheckboxes';
import { CONSENT_KEYS } from '../../lib/constants';
import Api from '../../Components/Api';

const FACEBOOK_APP_ID:any=process.env.REACT_APP_FACEBOOK_APP_ID

function GuestLogin(props: any) {
    const guestInfo = useSelector((state: any) => state.customer.guestInfo)
    const [isChecked, setIsChecked] = useState(false);
    const [showdetails, setShowDetaild] = useState(true)
    const history = useHistory();

    const handleCheckboxChange = (event: any) => {
        setIsChecked(event.target.checked);
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const [phone_number, setPhone_number] = useState('')
    const [otp, setOtp] = useState('')
    const [phoneError, setPhoneError] = useState(false);
    const [disable, setDisable] = useState(true);
    const [verifyBtnDisable, setVerifyBtnDisable] = useState(true);

    const [email, setEmail] = useState('')
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [gender, setGender] = useState('male');
    const [date, setDate] = useState('');
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [matchPasswordError, setMatchPasswordError] = useState(false);
    const [disableSignupBtn, setDisableSignupBtn] = useState(true);
    const [disableGuestBtn, setDisableGuestBtn] = useState(true);
    const [isChecked2, setIsChecked2] = useState(false);
    const [user, setUser]: any = useState([]);
    const [consentConfig, setConsentConfig] = useState<ConsentConfig>({});
    const [consentValues, setConsentValues] = useState<Partial<Record<typeof CONSENT_KEYS[number], boolean>>>({});
    const lang = useCurrentLocale();
    const [addEvent] = useTrackEvent();
    const { t } = useTranslation();

    useEffect(() => {
        let token: any = localStorage.getItem("userToken");
        if (token || guestInfo) {
            history.push(`/${lang}/payment-method`);
        }
    }, [])

    useEffect(() => {
        Api.get(`/customer/consent-config?lang_code=${lang}`)
            .then((res: any) => {
                const c: ConsentConfig = res?.data?.successResponse || {};
                setConsentConfig(c);
                const initial: Partial<Record<typeof CONSENT_KEYS[number], boolean>> = {};
                (Object.keys(c) as (typeof CONSENT_KEYS[number])[]).forEach((k) => {
                    initial[k] = !!c[k]?.preChecked;
                });
                setConsentValues(initial);
            })
            .catch(() => setConsentConfig({}));
    }, [lang]);

    const mandatoryConsentOk = () => {
        for (const key of Object.keys(consentConfig) as (typeof CONSENT_KEYS[number])[]) {
            if (consentConfig[key]?.mandatory && !consentValues[key]) return false;
        }
        return true;
    };

    const handlePhone = (e: any) => {
        const { value } = e.target;
        if (value.length <= NUMBERS_LIMIT) {
            setPhone_number(value);
        }
        if (!checkPhone(value)) return;
        if (value.length == NUMBERS_LIMIT) {
            setDisable(false)
        }
        if (value.length < NUMBERS_LIMIT) {
            setDisable(true);
        }
    };

    const handleEnterPress = (e: any) => {
        if (e.key == "Enter" && checkPhone(e.target.value)) {
            handleSendOtp()
        }
        else if (e.key == "Enter") {
            toast.error(t("PLEASE_ENTER_VALID_NUMBER"))
        }
    }
    const handleSendOtp = () => {
        props.sendOtp({
            phone_number: `${PHONE_CODE}-` + phone_number,
        },setShow)
        setShowDetaild(true)

    }
    const handleVerifyOtp = () => {
        const data: any = {
            phone_number: `${PHONE_CODE}-` + phone_number,
            otp: otp,
        }
        props.guestVerifyOtp(data, history, setShowDetaild)
    }
    useEffect(() => {
        if (otp.length >= 4) {
            handleVerifyOtp()
            setVerifyBtnDisable(false)
        }
        else {
            setVerifyBtnDisable(true)
        }

    }, [otp])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleSignup = () => {
        let obj: any = {
            first_name: firstname,
            last_name: "",
            login_name: firstname,
            email_address: email,
            login_password: password,
            phone_number: `${PHONE_CODE}-` + phone_number,
            is_active: 1,
            is_guest: 0

        }
        props.addGuest(obj, history);
    }
    const handleAddGuest = () => {
        let obj: any = {
            first_name: firstname,
            last_name: "",
            login_name: firstname,
            phone_number: `${PHONE_CODE}-` + phone_number,
            email_address: email,
            login_password:"",
            is_active: 1,
        };
        if (typeof consentValues.send_email !== 'undefined') obj.send_email = consentValues.send_email ? 1 : 0;
        if (typeof consentValues.send_pn !== 'undefined') obj.send_pn = consentValues.send_pn ? 1 : 0;
        if (typeof consentValues.send_sms !== 'undefined') obj.send_sms = consentValues.send_sms ? 1 : 0;
        if (typeof consentValues.check_policy !== 'undefined') obj.check_policy = consentValues.check_policy ? 1 : 0;
        props.signupNew(obj, history,"/payment-method")
    }

    const handleGoogleLogin = useGoogleLogin({
        onSuccess: (codeResponse: any) => setUser(codeResponse),
        onError: (error: any) => {}
    });

    useEffect(
        () => {
            if (user) {
                axios
                    .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                        headers: {
                            Authorization: `Bearer ${user.access_token}`,
                            Accept: 'application/json'
                        }
                    })
                    .then((res: any) => {
                        
                        let randomstring = uuid() + "_" + Date.now();
                        if (res.data.verified_email) {
                            const data: any = {
                                first_name: res.data.given_name,
                                last_name: res.data.family_name,
                                login_name: res.data.name,
                                email_address: res.data.email,
                                profile_pic: res.data.picture,
                                phone_number: randomstring,
                                is_active: 1,
                                is_social_login: 1
                            }
                            props.loginCustomerWithSocial(data, history,`/${lang}/payment-method`);
                        } else {
                            toast.error(t("YOUR_EMAIL_IS_NOT_VERIFIED_BY_GOOGLE"), { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 });
                        }
                    })
                    .catch((err: any) =>{});
            }
        },
        [user]
    );

    const responseFacebook = (response: any) => {
        let randomstring = uuid() + "_" + Date.now();
        const data: any = {
            first_name: response?.first_name,
            last_name: response?.last_name,
            login_name: response?.name,
            email_address: response?.email,
            phone_number: randomstring,
            profile_pic: response?.picture?.data?.url,
            is_active: 1,
            is_social_login: 1
        };
        if (response.status != "unknown") props.loginCustomerWithSocial(data, history,`/${lang}/payment-method`);
    }

    return (
        <>
                    <div >
                        <div className="login-guest mb-4">
                            <div className="row  position-relative">
                            <div className='detail-btn-back web-backbtn'>
                                        <GoBack />
                                        </div>
                                {
                                    /* <div className="col-md-6">
                                        <img src={KFCUncle} alt="KFCUncle" />
                                        </div> */
                                }
                                <div className="col-md-8 offset-md-2">
                                    
                                    <div className='welcome-login'>
                                       
                                        <h3 className='mb-0 detail--add'>
                                           {t("MY_DETAILS")}!
                                        </h3>
                                        
                                        <div className="col-md-12 mt-3">
                                            <TextField
                                                value={phone_number}
                                                onChange={handlePhone}
                                        className='field-style kfc-number-field' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("PHONE_NUMBER")} ({MOBILE_STARS})</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error"
                                                InputProps={{
                                                    startAdornment: <InputAdornment className='number-field' position="start">{PHONE_CODE}</InputAdornment>,
                                                    inputMode: 'numeric',
                                                }}
                                                helperText={phoneError ? t("PHONE_ERROR",{limit:NUMBERS_LIMIT}) : ""}
                                                onKeyPress={handleEnterPress}
                                                type='text'

                                            />
                                        </div>


                                        <div>
                                            <Button disabled={(disable || phoneError) ? true : false} onClick={handleSendOtp}
                                        className={`${(disable || phoneError) ? "disable-btn " : "able-btn"} m-auto d-flex mt-4 coupon-otp-btn w-100 font-medium`} variant="contained" color="error">{t("SEND_OTP")}</Button>
                                        <Link to={`/${lang}/login`}>   <Button className='bg-theme w-100 font-medium mt-2' variant="contained" color="error">{t("LOGIN")}</Button></Link>
                                            {/* <Button onClick={() => {
                                                handleGoogleLogin();
                                                addEvent({ category: "events", events: "Google Login Button" })
                                            }} className='bg-theme w-100 font-medium mt-2 fblogin position-relative' variant="contained" color="error">
                                                <i className="ri-google-fill socila-login"></i>    {t("LOGIN_WITH_GOOGLE")}
                                            </Button> */}
                                            {/* <span onClick={() => addEvent({ category: "events", events: "Facebook Login Button" })}>
                                                <FacebookLogin
                                                    appId={FACEBOOK_APP_ID}
                                                    autoLoad={false}
                                                    fields="id,name,email,first_name,last_name,picture.type(small)"
                                                    scope="public_profile,email"
                                                    callback={responseFacebook}
                                                    disableMobileRedirect={true}
                                                    icon={"ri-facebook-fill f-md socila-login"}
                                                    textButton="Login with Facebook"
                                                    cssClass="bg-theme w-100 font-medium mt-2 fblogin justify-content-around d-flex position-relative"
                                                />
                                            </span> */}
                                            <Modal className='payment-modal' show={show} onHide={handleClose} centered backdrop={"static"} >
                                                <div className='modal-design'>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                                <Modal.Header className='justify-content-center' closeButton>
                                                    <Modal.Title className='font-bold h4'>{showdetails? t("VALIDATE_OTP"):t("MY_DETAILS")}</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body className='w-100 delivery-order'>
                                                    {showdetails ?
                                                        <OtpModal otp={otp} setOtp={setOtp} phone_number={`${PHONE_CODE}-` + phone_number} />
                                                        :
                                                        <div className='guest-login-password'>
                                                            <LoginDetail
                                                              matchPasswordError={matchPasswordError}
                                                              setMatchPasswordError={setMatchPasswordError}
                                                              isChecked={isChecked2}
                                                              setIsChecked={setIsChecked2}
                                                              setDisableGuestBtn={setDisableGuestBtn}
                                                              password={password}
                                                              setPassword={setPassword}
                                                              confirmPassword={confirmPassword}
                                                              setConfirmPassword={setConfirmPassword}
                                                              passwordError={passwordError}
                                                              setPasswordError={setPasswordError}
                                                              confirmPasswordError={confirmPasswordError}
                                                              setConfirmPasswordError={setConfirmPasswordError}
                                                              emailError={emailError}
                                                              setEmailError={setEmailError}
                                                              setDisableSignupBtn={setDisableSignupBtn}
                                                              date={date}
                                                              setDate={setDate}
                                                              gender={gender}
                                                              setGender={setGender}
                                                              lastname={lastname}
                                                              setLastname={setLastname}
                                                              firstname={firstname}
                                                              setFirstname={setFirstname}
                                                              email={email}
                                                              setEmail={setEmail}
                                                              consentConfig={consentConfig}
                                                              consentValues={consentValues}
                                                              setConsentValues={setConsentValues}
                                                            />
                                                        </div>
                                                    }
                                                    <div className='d-flex justify-content-between gap-10'>
                                                        {showdetails ?
                                                        <div className='w-100'>
                                                            <Button disabled={verifyBtnDisable} onClick={handleVerifyOtp} className={`w-50 m-auto d-flex mt-4 bg-theme ${verifyBtnDisable ? "disable-btn" : "able-btn"}`} variant="contained" color="error">{t("VERIFY")}</Button>
                                                            </div>
                                                            : isChecked2 ?
                                                                <Button
                                                                  disabled={
                                                                    matchPasswordError ||
                                                                    disableSignupBtn ||
                                                                    emailError ||
                                                                    !firstname ||
                                                                    !date ||
                                                                    passwordError ||
                                                                    confirmPasswordError ||
                                                                    !mandatoryConsentOk()
                                                                  }
                                                                  onClick={handleSignup}
                                                                  className='w-50 m-auto d-flex mt-4 bg-theme mb-3'
                                                                  variant="contained"
                                                                  color="error"
                                                                >
                                                                  {t("SUBMIT_SIGNUP")}
                                                                </Button> :
                                                                <Button
                                                                  disabled={
                                                                    disableGuestBtn ||
                                                                    emailError ||
                                                                    !firstname ||
                                                                    !date ||
                                                                    !mandatoryConsentOk()
                                                                  }
                                                                  onClick={handleAddGuest}
                                                                  className='w-50 m-auto d-flex mt-4 bg-theme mb-3'
                                                                  variant="contained"
                                                                  color="error"
                                                                >
                                                                  {t("SUBMIT")}
                                                                </Button>
                                                        }
                                                    </div>
                                                </Modal.Body>

                                            </Modal>
                                        </div>
                                       
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div> 
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        addGuest: function (data: any, history?: any) {
            dispatch(addGuest(data, history));
        },
        sendOtp: function (data: any,setShow:any) {
            dispatch(sendOtp(data,setShow))
        },
        guestVerifyOtp: function (data: any, history?: any, setState?: any) {
            dispatch(guestVerifyOtp(data, history, setState))
        },
        changePasswordOtp: function (forgetPassword: any, history: any) {
            dispatch(changePasswordOtp(forgetPassword, history))
        },
        customerSignIn: function (data: any, history: any) {
            dispatch(customerSignIn(data, history))
        },
        loginCustomerWithSocial: function (data: any, history: any,route?:any) {
            dispatch(loginCustomerWithSocial(data, history,route))
        },
        signupNew: function (data: any,history?:any,route?:any) {
            dispatch(signupNew(data,history,route))
        },
        getConsentConfig: (langCode?: string) => dispatch(getConsentConfig(langCode)),
    }
}
export default connect(null, mapDispatchToProps)(GuestLogin);
